<template>
    <div>
        <c-form-element
            :label="'Datum tolkdienst'"
            :horizontal="true">
            <c-datepicker :required="true" v-model="datum" :name="'startdate'"></c-datepicker>
        </c-form-element>

        <c-form-element
            :label="'Begintijd tolkdienst'"
            :horizontal="true">
            <c-timepicker :name="'starttime'" :required="true" v-model="starttijd"></c-timepicker>
        </c-form-element>

        <c-form-element
            :label="'Eindtijd tolkdienst'"
            :horizontal="true">
            <c-timepicker :name="'endtime'" :required="true"  v-model="eindtijd"></c-timepicker>
        </c-form-element>
        <c-form-element
            :label="'Brontaal'"
            :horizontal="true"
            :clean="true">
            <c-select
                :options="languages"
                :required="true"
                :searchable="true"
                :name="'source'"
                v-model="brontaal"></c-select>
        </c-form-element>

        <c-form-element
            :label="'Doeltaal'"
            :horizontal="true"
            :clean="true">
            <c-select
                :options="languages"
                :required="true"
                :searchable="true"
                :name="'target'"
                :multiple="true"
                v-model="doeltaal"></c-select>
        </c-form-element>

        <c-form-element
            :label="'Aanwezigheid'"
            :horizontal="true">
            <c-radio :required="true" :name="'presence'" v-model="type_aanwezigheid" :options="[
                {label:'Fysiek', value:'Fysiek'},
                {label:'Telefonisch', value:'Telefonisch'},
                {label:'Virtueel', value:'Virtueel'}
                ]"></c-radio>
        </c-form-element>

        <c-form-element
            v-if="type_aanwezigheid == 'Fysiek'"
            :label="'Postcode en hnr.'"
            :horizontal="true">
            <c-address
                @input="setAddress"
                :zipcode="postcode"
                :housenumber="huisnummer"
                :addition="huisnummertoevoeging"
                :street="straat"
                :city="plaats"
            ></c-address>
        </c-form-element>

        <c-form-element
            v-else-if="type_aanwezigheid == 'Virtueel'"
            :label="'Online URL'"
            :horizontal="true">
            <input type="text" v-model="aanwezigheid_url" required name="aanwezigheid_url"/>
        </c-form-element>

        <c-form-element
            :label="'Urgentie'"
            :horizontal="true">
            <c-radio :required="true" :name="'urgency-applicant'" v-model="is_urgent" :options="[
                {label:'Laag', value:0},
                {label:'Hoog', value:1}
                ]"></c-radio>
        </c-form-element>

        <template v-if="user.is_planner">
            <c-form-element
                :label="'Spoed'"
                :horizontal="true">
                <c-radio :required="true" :name="'urgency-planner'" v-model="is_spoed" :options="[
                    {label:'Regulier', value:0},
                    {label:'Spoed', value:1}
                    ]"></c-radio>
            </c-form-element>

            <c-form-element
                v-show="is_spoed == 1"
                :label="'Spoedtarief'"
                :horizontal="true">
                <input type="number" v-model="spoedtarief" step="0.01" :required="is_spoed == 1" name="express-rate"/>
            </c-form-element>
        </template>

        <c-form-element
            :label="'Administratief kenmerk'"
            :horizontal="true">
            <input type="text" v-model="kenmerk" required name="characteristic"/>
        </c-form-element>

        <c-form-element
            :label="'Telefoonnummer Vast'"
            :horizontal="true">
            <input type="text" v-model="telefoon_vast" name="phonenumber"/>
        </c-form-element>

        <c-form-element
            :label="'Telefoonnummer Mobiel'"
            :horizontal="true">
            <input type="text" v-model="telefoon_mobiel" name="phonenumber"/>
        </c-form-element>

        <c-form-element
            :label="'Naam gespreksvoerder'"
            :horizontal="true">
            <input type="text" v-model="naam_gespreksvoerder" required name="name_interviewer"/>
        </c-form-element>

        <c-form-element
            :label="'Opmerking en instructies'"
            :horizontal="true">
            <c-textarea v-model="instructies" :name="'remark'"></c-textarea>
        </c-form-element>

        <c-form-element
            :label="'Notities'"
            :horizontal="true">
            <c-textarea v-model="notitie" :name="'notes'"></c-textarea>
        </c-form-element>
    </div>
</template>

<script>
import Form from '@mixins/Form';
import View from '@mixins/View';
import { mapState } from 'vuex';

export default {
    mixins: [ Form, View ],
    props: {
        edit: {
            required: false
        },
        initialDate: {
            default: undefined
        }
    },
    watch:{
        initialDate(val){
            this.datum = val;
        }
    },
    data() {
        return {
            datum: '',
            starttijd: '',
            eindtijd:'',
            brontaal: '',
            doeltaal: '',
            type_aanwezigheid: 'Fysiek',
            aanwezigheid_url: '',
            is_urgent: 0,
            is_spoed: 0,
            spoedtarief: 0,
            kenmerk: '',
            telefoon_vast: '',
            telefoon_mobiel: '',
            naam_gespreksvoerder: '',
            instructies: '',
            postcode: '',
            huisnummer: '',
            huisnummertoevoeging: '',
            straat: '',
            plaats: '',
            notitie: ''
        }
    },
    methods: {
        setAddress(address) {
            this.postcode = address.zipcode;
            this.huisnummer = address.housenumber;
            this.huisnummertoevoeging = address.addition;
            this.straat = address.street;
            this.plaats = address.city;
        }
    },
    computed: {
        ...mapState({
            languages: state => state.preferences.data.interpreterLanguages,
            user: state => state.user.data
        })
    },
    mounted() {
        if ( this.user.opdrachtgever ) {
            this.telefoon_vast = this.user.opdrachtgever.adres.telefoon_vast;
            this.telefoon_mobiel = this.user.opdrachtgever.adres.telefoon_mobiel;
        }

        if ( typeof this.initialDate !== 'undefined' ) {
            this.datum = this.initialDate;
        }
    }
}
</script>
